import React from 'react';
import { Panel, Breadcrumb } from 'rsuite';
import ContentPage from './ContentPage';
import { useTranslation } from 'react-i18next';
const Page = () => {
  const { t } = useTranslation();

  return (
    
    <Panel
      header={
        <>
          <h3 className="title">{t('Real Time Maps')}</h3>{' '}
          <Breadcrumb>
            <Breadcrumb.Item href="/">{t('Home')}</Breadcrumb.Item>
            <Breadcrumb.Item active>{t('Floor maps')}</Breadcrumb.Item>
          </Breadcrumb>
        </>
      }
    >
      <ContentPage />
    </Panel>
  );
};

export default Page;
